import './App.css';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'jquery/dist/jquery.min.js';
import 'bootstrap/dist/js/bootstrap.min.js';
import './Components/Styles/CustomColors.css';

import Login from './Components/Login';
import Register from './Components/Register';
import Lobby from './Components/Lobby.js';
import GameHub from './Components/GameHub.js';
import MainMenu from './Components/MainMenu.js';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  return (
    <Router>
      <div className="App">
        <Routes>
          <Route
            path="/login"
            element={
              <Login onLogin={() => setIsAuthenticated(true)} />
            }
          />
          <Route path="/register" element={<Register />} />

          <Route
            path="/mainmenu"
            element={
              isAuthenticated ? (
                <MainMenu onLogout={() => setIsAuthenticated(false)} />
              ) : (
                <Navigate to="/login" replace />
              )
            }
          />

          <Route
            path="/gamehub"
            element={
              isAuthenticated ? (
                <GameHub />
              ) : (
                <Navigate to="/login" replace />
              )
            }
          />

          <Route
            path="/lobby"
            element={
              isAuthenticated ? (
                <Lobby />
              ) : (
                <Navigate to="/login" replace />
              )
            }
          />

          <Route
            path="/"
            element={<Navigate to={isAuthenticated ? "/mainmenu" : "/login"} replace />}
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;